import React, { useEffect } from 'react';
import { useState } from 'react';
import { TextField, Box } from '@mui/material';



function InputContainer(props) {

    const propsValue = props.value;
    const [value, setValue] = useState('');
    const label = props.label;
    const tiny = props.tiny;
    const multiline = props.multiline ?? false;


    const handleChange = (e) => {


        setValue(e.target.value);
        if (props.onInputChange) {
            props.onInputChange(e.target.value);
        }
    }

    const handleBlur = (e) => {
        setValue(e.target.value);
        if (props.onBlur) {
            props.onBlur(e.target.value);
        }
    }

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            props.onEnter(value)
        }
    }

    useEffect(() => {
        setValue(propsValue);

        // eslint-disable-next-line
    }, [propsValue]);

    const style = tiny ? { style: { height: 30, fontSize: 12 } } : {};




    return (
        <Box sx={{ width: '100%' }}>

            <TextField multiline={multiline} size='small' InputLabelProps={{
                shrink: !!value || undefined,
            }} InputProps={style} sx={{ width: '100%', backgroundColor: 'white' }} label={label} value={value} onBlur={handleBlur} onKeyPress={handleKeyPress} onChange={handleChange} />
        </Box>

    )

}

export default InputContainer;

